export const SUCCESS_REPONSE_CODE = 200;
export const UNAUTHORIZED_REPONSE_CODE = 401;
export const RESOURCE_NOT_FOUND_REPONSE_CODE = 404;
export const UNPROCESSABLE_ENTITY_RESPONSE_CODE = 422;
export const SERVER_ERROR_RESPONSE_CODE = 500;
